module.exports = __webpack_public_path__ + "static/media/ServiceFLB.1c0b4cfd.jpeg";